import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { useAsyncQuery } from './useAsyncQuery'

export const useEvents = () => {
  const fetchEvents = async () => {
    // Callers here want the whole collection, not a page, so they ask for the
    // server's maximum explicitly rather than relying on the default page size.
    const response = await axios.get(`${API_BASE_URL}/api/events/my-events?limit=100`, {
      withCredentials: true
    })
    return response.data.events || []
  }

  const { data: events, loading, error, refetch } = useAsyncQuery(
    fetchEvents,
    [],
    { initialData: [] }
  )

  return { events, loading, error, refetch }
}
